var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97772 3.03919L9.80021 4.68418C9.91104 4.91168 10.2085 5.12751 10.4594 5.17418L11.9469 5.41918C12.8977 5.57668 13.1194 6.26502 12.4369 6.95335L11.276 8.11419C11.0835 8.30669 10.9727 8.68585 11.0369 8.96002L11.3694 10.395C11.6319 11.5267 11.0252 11.97 10.0277 11.375L8.63354 10.5467C8.38271 10.395 7.96272 10.395 7.71188 10.5467L6.31771 11.375C5.32021 11.9642 4.71355 11.5267 4.97605 10.395L5.30855 8.96002C5.37272 8.69168 5.26188 8.31252 5.06938 8.11419L3.90856 6.95335C3.22606 6.27085 3.44772 5.58251 4.39855 5.41918L5.88605 5.17418C6.13688 5.13335 6.43438 4.91168 6.54522 4.68418L7.36772 3.03919C7.80522 2.14669 8.52856 2.14669 8.97772 3.03919Z",
    stroke: "#FF9900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 2.91669H1.1665",
    stroke: "#FF9900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9165 11.0833H1.1665",
    stroke: "#FF9900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74984 7H1.1665",
    stroke: "#FF9900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ff7b5114cb2eb024ca68dad48af608c5.svg";
export { ForwardRef as ReactComponent };